import * as React from 'react'
import { Outlet } from 'react-router-dom'

import { useApolloClient } from '@apollo/client'
import { GetCustomTableNameDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import schemas from 'modules/custom_resources/store/collections/customResources/schemas'
import Schema from 'modules/custom_resources/store/models/customResources/Schema'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import Content from './_Content'

interface Props {
  schemaId: number
}

export default function CustomTablePage({ schemaId }: Props) {
  const schema = schemas.get(schemaId)
  const apolloClient = useApolloClient()

  const { loading } = useAsyncData(
    () =>
      schemas.fetch({
        data: {
          topic_names: [Schema.TOPIC_NAMES.employees, Schema.TOPIC_NAMES.performance],
        },
      }),
    []
  )

  const updateSchema = async (name: string) => {
    if (schema) {
      await schema.save({
        name,
      })
      return apolloClient.refetchQueries({
        include: [GetCustomTableNameDocument],
      })
    }
  }

  if (loading) return <Loading />

  return (
    <ResponsivePage.Body showHeader={false}>
      {schema ? <Content schema={schema} updateSchema={updateSchema} /> : null}
      <Outlet
        context={{
          schemaId,
        }}
      />
    </ResponsivePage.Body>
  )
}
